module.exports = __webpack_public_path__ + "media/images/stream_preview_portrait-f04fb8004caad3f7d0def282fae80b74.png";